import React from 'react';
import { Stack } from '@mui/material';
import AppIcon from '../Icons/AppIcon';
import { mdiFolder } from '@mdi/js';
import { useNavigate, useParams } from 'react-router-dom';
import { labelFontSemiBold, vars } from '../../../Theme';
import { useDispatch } from 'react-redux';
import { setSelectedNodes } from '../../../redux/import/sliceDocnumberSidepanel';
import { getAscendants } from '../../../util/StructureUtils';
import { setExpandedNodes } from '../../../redux/import/sliceImportData';

/**
 * Component that shows a category folder as a row.
 */
export default ({ id, name }: IDocTableCategoryRowProps) => {
    const { replicaId, areaName, viewName } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /** Navigate to clicked category. */
    const handleClick = () => {
        if (areaName === 'import') {
            const ascendants = getAscendants(id).map(x => x.id);
            dispatch(setSelectedNodes({ current: id, all: [id, ...ascendants] }));
            dispatch(setExpandedNodes([id, ...ascendants]));
            return;
        }
        return navigate(`/project/${replicaId}/${areaName}/${viewName}/${id}`);
    };

    return (
        <Stack
            onClick={handleClick}
            direction='row'
            spacing={2}
            sx={{
                alignItems: 'center',
                flexGrow: 4,
                cursor: 'pointer',
                px: 1,
            }}
        >
            <AppIcon path={mdiFolder} color={vars.font} tooltipPlacement='top-start' />
            <Stack sx={{ ...labelFontSemiBold, fontSize: 14, lineHeight: 1 }}>{name}</Stack>
        </Stack>
    );
};

/**
 * Interface that describes the props for a DocTableCategoryRow component.
 */
export interface IDocTableCategoryRowProps {
    /** Unique identifier of the category. */
    id: string;

    /** Title of the category. */
    name: string | JSX.Element;
}
